// extracted by mini-css-extract-plugin
export var inlineLink = "_ah-0";
export var inlineLinkButton = "_ah-1";